const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicroticaBigLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 579,
    height: 452,
    viewBox: "0 0 579 452",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#F3F2F2",
    fillRule: "evenodd",
    d: "M487.31 360.93c-27.03-47.077-75.492-65.183-113.553-22.363-58.455 65.753-65.783 116.75-135.914 108.4C165.58 438.36 78.93 228.056 30.958 456c0 0-54.198-56.787-60.648-161.311-3.093-50.066 16.745-103.188 67.961-126.468 75.695-34.416 118.712 46.454 161.721 37.856 58.823-11.768 34.18-80.825 88.114-157.94 73.682-105.336 233.046-20.839 271.46 90.835 62.645 182.105-46.2 309.406-46.2 309.406s-4.46-49.818-26.056-87.448z",
    opacity: 0.145,
    style: {
      mixBlendMode: "overlay"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroticaBigLogo);
export default __webpack_public_path__ + "static/media/microtica-big-logo.4c00eeee.svg";
export { ForwardRef as ReactComponent };